// extracted by mini-css-extract-plugin
module.exports = {"searchField":"searchForm_searchField__1KZGN","icons":"searchForm_icons__-KmBf"};